import { buttonStyles } from '@/shared/ui/Button'

export function BoardPagination(props: {
  page: number
  pages: number
  onChange: (page: number) => void
}) {
  if (props.pages <= 1) return null

  return (
    <nav className="mt-6 flex items-center justify-center gap-3" aria-label="쪽 이동">
      <button
        type="button"
        className={buttonStyles('md', 'assistive')}
        disabled={props.page <= 1}
        onClick={() => props.onChange(props.page - 1)}
      >
        이전
      </button>

      <span className="text-body-sm text-black-100">
        {props.page} / {props.pages}
      </span>

      <button
        type="button"
        className={buttonStyles('md', 'assistive')}
        disabled={props.page >= props.pages}
        onClick={() => props.onChange(props.page + 1)}
      >
        다음
      </button>
    </nav>
  )
}
